/**
 * A teacher's own classroom PIN (D-396).
 *
 * Separate from the admin route, which is `ManageStaff` and reaches anybody.
 * These two reach one staff row: hers, decided by the server from the loaded
 * account and never from anything sent (D-72).
 */
export async function fetchPinStatus(): Promise<{ hasPin: boolean }> {
  const res = await fetch('/api/account/pin')

  // 404 is a parent, who has no staff row and no register a PIN would open.
  if (res.status === 404) return { hasPin: false }
  if (!res.ok) throw new Error(`Could not check your PIN (${res.status})`)

  return res.json()
}

/**
 * The panel never sends an empty PIN — the button is disabled until she has
 * typed one. The route would accept it and clear hers, which is what the admin
 * route needs and what sharing one handler means (D-396).
 */
export async function setOwnPin(pin: string): Promise<void> {
  const res = await fetch('/api/account/pin', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  })

  if (!res.ok) {
    // The server's refusals are written for the person reading them - four
    // digits, not the same digit repeated - so they are shown rather than
    // replaced with a generic message.
    const body = await res.json().catch(() => null)
    throw new Error(body?.error ?? `Could not save that (${res.status})`)
  }
}
